export { default as DataQuery } from "./DataQuery"
